import React from "react";
import { SVGProps } from "react";

export default function Car(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_246_6652"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <rect width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_246_6652)">
        <path
          d="M10 31.6654V33.332C10 33.8043 9.84028 34.2001 9.52083 34.5195C9.20139 34.839 8.80556 34.9987 8.33333 34.9987H6.66667C6.19444 34.9987 5.79861 34.839 5.47917 34.5195C5.15972 34.2001 5 33.8043 5 33.332V19.9987L8.5 9.9987C8.66667 9.4987 8.96528 9.09592 9.39583 8.79036C9.82639 8.48481 10.3056 8.33203 10.8333 8.33203H29.1667C29.6944 8.33203 30.1736 8.48481 30.6042 8.79036C31.0347 9.09592 31.3333 9.4987 31.5 9.9987L35 19.9987V33.332C35 33.8043 34.8403 34.2001 34.5208 34.5195C34.2014 34.839 33.8056 34.9987 33.3333 34.9987H31.6667C31.1944 34.9987 30.7986 34.839 30.4792 34.5195C30.1597 34.2001 30 33.8043 30 33.332V31.6654H10ZM9.66667 16.6654H30.3333L28.5833 11.6654H11.4167L9.66667 16.6654ZM12.5 26.6654C13.1944 26.6654 13.7847 26.4223 14.2708 25.9362C14.7569 25.4501 15 24.8598 15 24.1654C15 23.4709 14.7569 22.8806 14.2708 22.3945C13.7847 21.9084 13.1944 21.6654 12.5 21.6654C11.8056 21.6654 11.2153 21.9084 10.7292 22.3945C10.2431 22.8806 10 23.4709 10 24.1654C10 24.8598 10.2431 25.4501 10.7292 25.9362C11.2153 26.4223 11.8056 26.6654 12.5 26.6654ZM27.5 26.6654C28.1944 26.6654 28.7847 26.4223 29.2708 25.9362C29.7569 25.4501 30 24.8598 30 24.1654C30 23.4709 29.7569 22.8806 29.2708 22.3945C28.7847 21.9084 28.1944 21.6654 27.5 21.6654C26.8056 21.6654 26.2153 21.9084 25.7292 22.3945C25.2431 22.8806 25 23.4709 25 24.1654C25 24.8598 25.2431 25.4501 25.7292 25.9362C26.2153 26.4223 26.8056 26.6654 27.5 26.6654Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
}
